'use strict'

module.exports = {
  'SET_CURRENT_RECORD': 'SET_CURRENT_RECORD',
  'UPDATE_FIELDS': 'UPDATE_FIELDS',
  'CLEAR_CURRENT_RECORD': 'CLEAR_CURRENT_RECORD',
  'REFRESH_CURRENT_RECORD': 'REFRESH_CURRENT_RECORD',
  'REFRESH_CURRENT_VIEW': 'REFRESH_CURRENT_VIEW',
  'RESET_REFRESH_CURRENT_VIEW': 'RESET_REFRESH_CURRENT_VIEW',
  'INCREMENT_NUM_PAGES_TO_SHOW': 'INCREMENT_NUM_PAGES_TO_SHOW',
  'SET_DEFAULT_RECORD': 'SET_DEFAULT_RECORD',
  'GO_TO_INDEX': 'GO_TO_INDEX',
  'GO_TO_NEXT_PAGE': 'GO_TO_NEXT_PAGE',
  'GO_TO_PREVIOUS_PAGE': 'GO_TO_PREVIOUS_PAGE'
}



// WEBPACK FOOTER //
// ./records/actionTypes.js